module.exports = __webpack_public_path__ + "img/connect.37b87cbf.png";